module.exports = __webpack_public_path__ + "img/w-recurring-charges.b2189101.svg";